import { render } from "./icon-cart.vue?vue&type=template&id=4e217699"
import script from "./icon-cart.vue?vue&type=script&lang=js"
export * from "./icon-cart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__